var _defs, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCaptureCall = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n                        .a {\r\n                          fill: #5cc5ff;\r\n                        }\r\n\r\n                        .b,\r\n                        .c,\r\n                        .d,\r\n                        .e,\r\n                        .g {\r\n                          fill: none;\r\n                        }\r\n\r\n                        .b,\r\n                        .d {\r\n                          stroke: #015da8;\r\n                        }\r\n\r\n                        .c,\r\n                        .e {\r\n                          stroke: #5cc5ff;\r\n                        }\r\n\r\n                        .d {\r\n                          stroke-dasharray: 2 0;\r\n                        }\r\n\r\n                        .e {\r\n                          stroke-dasharray: 2 2;\r\n                        }\r\n\r\n                        .f {\r\n                          stroke: none;\r\n                        }\r\n                      "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-899.11 -445.11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(929.835 475.835)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.553,26.009l-5.167,5a35.278,35.278,0,0,1-7.441-5.76,35.871,35.871,0,0,1-5.793-7.478l5-5.068L9.666,1.748,3.444,7.93A7.83,7.83,0,0,0,1.92,16.878,56.875,56.875,0,0,0,13.969,33.466,68.679,68.679,0,0,0,32.3,46.659a7.749,7.749,0,0,0,3.392.78,7.853,7.853,0,0,0,5.553-2.3l6.193-6.216Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.553,26.009l-5.167,5a35.278,35.278,0,0,1-7.441-5.76,35.871,35.871,0,0,1-5.793-7.478l5-5.068L8.524,0,2.3,6.182A7.83,7.83,0,0,0,.779,15.13a68.7,68.7,0,0,0,13.19,18.335A68.679,68.679,0,0,0,32.3,46.659a7.749,7.749,0,0,0,3.392.78,7.853,7.853,0,0,0,5.553-2.3l6.193-6.216Z",
    transform: "translate(0.001 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.405,19.01H11.981V5.582h3.7v7.1L28.368,0l2.619,2.619L25.649,7.958,18.3,15.306h7.1Zm0,0",
    transform: "translate(16.441 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(899.11 445.11)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 54.5,
    cy: 54.5,
    r: 54.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 54.5,
    cy: 54.5,
    r: 54
  })), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 21.348,
    y2: 21.348,
    transform: "translate(919.162 512.601)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 9.488,
    y2: 9.488,
    transform: "translate(978.461 465.162)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCaptureCall, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/capture-call.7b346752.svg";
export { ForwardRef as ReactComponent };